import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewChecked,
  ChangeDetectorRef,
  OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { marked } from 'marked';
import { ChatService, Message } from '../../services/chat-service/chat-service';
import { environment } from '../../../environments/environment.prod';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AgentInformationModel } from '../../models/agentinformationmodel';


@Component({
  selector: 'app-chat',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './chat.html',
  styleUrls: ['./chat.css'],
  providers: []
})
export class ChatComponent implements AfterViewChecked, OnInit {
  baseUrl = environment.baseUrl;

  /* ===================================================== */
  /* View References */
  /* ===================================================== */
  @ViewChild('chatContainer') private chatContainer!: ElementRef;

  /* ===================================================== */
  /* Widget State */
  /* ===================================================== */
  isOpen = false;
  isLoading = false;

  /* ===================================================== */
  /* Input / API Key */
  /* ===================================================== */
  userInput = '';
 
  /* ===================================================== */
  /* ✅ GLOBAL MESSAGES (Service-Owned State) */
  /* ===================================================== */
  messages!: Message[];
  agent: AgentInformationModel = null;

  constructor(
    private chatService: ChatService,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {
    this.messages = this.chatService.messages;
  }

  ngOnInit() {
    this.getAgentInformationData();
  }

  /* ===================================================== */
  /* Widget Toggle */
  /* ===================================================== */
  toggleChat(): void {
    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      setTimeout(() => this.scrollToBottom(), 0);
    }
  }

  /* ===================================================== */
  /* Call Service To Get Agent Information */
  /* ===================================================== */
  getAgentInformationData() {
    this.chatService
      .getAgentInformation()
      .subscribe({
        next: (res: AgentInformationModel) => {
          console.log(`Chat Agent: ${res.displayName} v${res.version}`);

          this.messages[0].content = res.description;
          this.agent = res;
          this.cdr.detectChanges();
        },
        error: () => {
          this.messages[0].content = 'Sorry, something went wrong. Please try again later.';
          this.cdr.detectChanges();
        }
      })
  }


  /* ===================================================== */
  /* Lifecycle */
  /* ===================================================== */
  ngAfterViewChecked(): void {
    this.scrollToBottom();
  }

  /* ===================================================== */
  /* Scrolling */
  /* ===================================================== */
  private scrollToBottom(): void {
    try {
      if (this.chatContainer) {
        this.chatContainer.nativeElement.scrollTop =
          this.chatContainer.nativeElement.scrollHeight;
      }
    } catch {
      /* no-op */
    }
  }

  /* ===================================================== */
  /* Format Message
  /* ===================================================== */


  formatMessage(content: string): SafeHtml {


    if (!content) {
      return '';
    }

    let html = marked.parse(content).toString();
    return this.sanitizer.bypassSecurityTrustHtml(html);

  }

  /* ===================================================== */
  /* Messaging */
  /* ===================================================== */
  sendMessage(): void {

    if (!this.userInput.trim() || this.isLoading) {
      return;
    }

    // Push user message
    this.chatService.messages.push({
      role: 'user',
      content: this.userInput.trim(),
      timestamp: new Date()
    });

    this.userInput = '';
    this.isLoading = true;

    // Temporary assistant placeholder
    this.chatService.messages.push({
      role: 'assistant',
      content: 'Thinking...',
      timestamp: new Date()
    });


    this.chatService.sendMessage().subscribe({
      next: (aiMessage) => {
        this.chatService.messages.pop();
        this.chatService.messages.push(aiMessage);
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.chatService.messages.pop();
        this.chatService.messages.push({
          role: 'assistant',
          content: 'Sorry, something went wrong. Please try again.',
          timestamp: new Date()
        });
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

}
